import { LoadingOutlined } from "@ant-design/icons";
import { PropsWithChildren } from "react";
import { useApplicationContext } from "src/hooks/useApplication";
import {
  relatedEntityContext,
  useRelatedEntity,
  useRelatedEntityContext,
} from "./useRelatedEntity";
import { VzblTag } from "./components/VzblTag";
import { useEntityContext } from "./useEntityContext";

export const RelatedEntity = (
  props: PropsWithChildren<{
    orgId: string;
    entityUuid: string;
    relation: string;
    direction?: string;
    type?: string;
  }>
) => {
  const relatedEntity = useRelatedEntity({
    orgId: props.orgId,
    entityUuid: props.entityUuid,
    relation: props.relation,
    direction: props.direction,
    type: props.type,
  });
  return (
    <relatedEntityContext.Provider value={relatedEntity}>
      {props.children}
    </relatedEntityContext.Provider>
  );
};

export const RelatedVzblTag = (props: { asLink?: boolean }) => {
  const orgId = useApplicationContext().org_id!;
  const context = useEntityContext();
  const { query } = useRelatedEntityContext();
  if (!orgId) {
    return null;
  }
  if (!query.isFetched) {
    query.refetch();
  }
  if (query.isLoading) {
    return <LoadingOutlined />;
  }
  return (
    <>
      {query.data?.related ? (
        <VzblTag
          asLink={props.asLink}
          orgId={orgId}
          context={context}
          text={query.data?.related.properties.name}
          color="none"
          entityUuid={query.data?.related.properties.uuid}
        />
      ) : (
        <>None</>
      )}
    </>
  );
};
